var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('TopBar',{attrs:{"scenename":_vm.scenename}}),_c('div',{staticClass:"downcontent"},[_c('LeftBar',{attrs:{"hasInfos":_vm.hasInfos,"activeIndex":_vm.nowActiveIndex}}),_c('router-view',{ref:"viewLink",attrs:{"panoEditInfos":_vm.panoEditInfos,"infos":_vm.resInfos,"nowFloor":_vm.nowFloor,"resData":_vm.resData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }